import React, { useState, useEffect } from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink } from 'react-router-dom';
import { IntrigrationLeftSec } from '../components/intrigrationLeftSec';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from "react-scroll-to-top";
import config from '../Config';

import { IntegrantionModuleService } from '../services/IntegrantionModuleService';
import { log } from 'console';

interface IState
{
    loading: boolean;
    module: any;
    errorMsg: string;
}

export const IntegrationsOdoo=() =>
{

    const [ state, setState ]=useState<IState>( {
        loading: false,
        module: [] as any,
        errorMsg: "",
    } );

    //network request
    useEffect( () =>
    {
        setState( { ...state, loading: true } );
        IntegrantionModuleService.getModuleDetails( 'Odoo' )
            .then( ( res ) =>
            {
                setState( {
                    ...state,
                    loading: false,
                    module: res.data as any,
                } )

            }

            )
            .catch( ( err ) =>
            {
                setState( {
                    ...state,
                    loading: false,
                    errorMsg: err.message,
                } )

            }
            );
        //eslint-disable-next-line
    }, [] );


    const { loading, module, errorMsg }=state;
    const modDetails=module.response?.module_details;
    const latestVersion=module.response?.module_details.length>0? module.response.module_details[ 0 ]:[];
    const contentDetArr=module.response?.module_details.length>0? module.response.module_details[ 0 ].jsoncontent:[];
    console.log( latestVersion );

    return (
        <>
            <section className="credit-api-main">
                <img src={ `${ config.siteBaseUrl }/assets/imgs/our-integrations-bg.svg` } alt="" className='apibg' />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <IntrigrationLeftSec />
                        </div>
                        <div className="col-lg-9">
                            <div className="creadit-api-upper-wrapper">
                                <Link to="/integrations" className='apidetail-btn'><FontAwesomeIcon icon={ faArrowRight } /> Return to Integrations page</Link>
                                <h1>Odoo</h1>

                                <ul className="card-url">
                                    <li>
                                        <div className="card-url-list">
                                            <p>Release:</p> <span>Version 1.0.0</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Payment Methods:</p>
                                            <span>Credit Card, ACH / Bank Transfer</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Odoo Version:</p>
                                            <span>18.0</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Odoo Edition:</p>
                                            <span>Community or Enterprise</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="card-url-list">
                                            <p>Odoo Hosting:</p>
                                            <span> On-premises or Odoo.sh (not available on Odoo Online / SaaS, as custom modules cannot be installed there) </span>
                                        </div>
                                    </li>
                                </ul>
                                <p className='mt-30'> This plugin allows you to use TCB Pay as an additional payment option for your Odoo website. </p>
                            </div>

                            <div className="creadit-api-lower-wrapper">
                                <div className="api-menu-item-wrapper">
                                    <h3>Installation</h3>
                                    <hr />
                                    { latestVersion.download_url&&latestVersion.file_name&&
                                        <Link to={ `${ config.pluginModuleUrl }/${ latestVersion.download_url }/${ latestVersion.file_name }` } target='_blank' className="integration-btn1 mb-20">Download the Odoo custom add-on<FontAwesomeIcon icon={ faArrowRight } /></Link>
                                    }
                                    { modDetails?.length>1&&
                                        <>
                                            <p>Download older versions of the package:</p>
                                            <div className="listintri">
                                                <ul>
                                                    { modDetails?.map( ( keyName: any ) => (
                                                        <>
                                                            <li>Download <Link to={ `${ config.pluginModuleUrl }/${ keyName.download_url }/${ keyName.file_name }` } target='_blank'>{ keyName.version_name }</Link>
                                                                { keyName.dependency? `for ${ keyName.dependency }`:"" }</li>
                                                        </>
                                                    ) )
                                                    }
                                                </ul>
                                            </div>

                                        </>
                                    }

                                </div>

                                <p>There are two ways to install the plugin.</p>

                                {/* <h5 className="mt-20">
                                    Method A — Install through the Apps interface (easiest)
                                </h5>

                                <p>
                                    Use this if your Odoo allows uploading modules from the browser.
                                </p>

                                <div className="example-box-wrapper mt-30 mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>1 </b>
                                        <p>Log in to Odoo as an administrator.</p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>2 </b>
                                        <p>
                                            Activate Developer Mode: go to <strong>Settings</strong>,
                                            scroll to the bottom, and click
                                            <strong> Activate the developer mode</strong>.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>3 </b>
                                        <p>Open the <strong>Apps</strong> menu.</p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>4 </b>
                                        <p>
                                            Click <strong>⋮</strong> (top-right) →
                                            <strong> Import Module</strong> (or
                                            <strong> Upload Module</strong>).
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>5 </b>
                                        <p>
                                            Select the
                                            <strong> tcbpay_odoo_payment_gateway.zip</strong> file,
                                            choose to install dependencies if prompted,
                                            and click <strong>Import</strong>.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>6 </b>
                                        <p>
                                            Wait for Odoo to install the module.
                                            Once finished, TCB Pay is ready to configure.
                                        </p>
                                    </div>
                                </div>
                                <img src="../assets/imgs/odoo1.png" alt="Method A" /> */}

                                <h5 className="mt-60">
                                    Method A — Install manually via the addons folder (on-premises)
                                </h5>

                                <p>
                                    Use this on a self-hosted server where you have file-system access.
                                </p>

                                <div className="example-box-wrapper mt-30 mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>1 </b>
                                        <p>
                                            Copy the
                                            <strong> tcbpay_odoo_payment_gateway </strong>
                                            module folder into your custom add-ons directory,
                                            for example:&nbsp;

                                            <span>
                                                /opt/odoo/custom-addons/tcbpay_odoo_payment_gateway
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>2 </b>
                                        <p>
                                            Confirm this directory is listed in the
                                            <strong> addons_path</strong> of your
                                            <strong> odoo.conf </strong>
                                            (typically <strong>/etc/odoo/odoo.conf</strong>):&nbsp;

                                            <span>
                                                addons_path = /opt/odoo/addons,/opt/odoo/custom-addons
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>3 </b>
                                        <p>
                                            Restart the Odoo service so it detects the new module:&nbsp;

                                            <span>
                                                sudo systemctl restart odoo
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>4 </b>
                                        <p>
                                            In Odoo, activate Developer Mode
                                            (<strong>Settings → bottom of page</strong>).
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>5 </b>
                                        <p>
                                            Open <strong>Apps</strong>, click
                                            <strong> Update Apps List</strong>, and confirm.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>6 </b>
                                        <p>
                                            Search for <strong>TCB Pay</strong>,
                                            then click <strong>Install</strong>.
                                        </p>
                                    </div>
                                </div>
                                <img src="../assets/imgs/odoo2.png" alt="Method B" />

                                <h5 className="mt-60">
                                    Method B — Deploy via Odoo.sh
                                </h5>

                                <p>
                                    Use this method for Odoo.sh-hosted instances.
                                </p>

                                <div className="example-box-wrapper mt-30 mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>1 </b>
                                        <p>
                                            Add the <strong>tcbpay_odoo_payment_gateway</strong> module to the Git
                                            repository connected to your Odoo.sh project.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>2 </b>
                                        <p>
                                            Commit and push the changes to a
                                            <strong> development </strong>
                                            or
                                            <strong> staging </strong>
                                            branch.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>3 </b>
                                        <p>
                                            Odoo.sh automatically builds the branch and installs the module
                                            during the deployment process.
                                        </p>
                                    </div>
                                </div>

                                <div className="example-box-wrapper mb-30">
                                    <div className="d-flex align-items-start">
                                        <b>4 </b>
                                        <p>
                                            Test the integration using the build's URL, then promote the branch
                                            to <strong>production</strong> when you are ready to go live.
                                        </p>
                                    </div>
                                </div>

                            </div>

                            <div className="creadit-api-lower-wrapper">
                                <div className="api-menu-item-wrapper">
                                    <h3>Configuration</h3>
                                    <p>Once installed, connect the module to your TCB Pay account.</p>
                                    <div className="example-box-wrapper mb-30">
                                        <div className="d-flex align-items-start">
                                            <b>1 </b>
                                            <div>
                                                <p>
                                                    Go to <strong>Accounting → Configuration → Payment Providers </strong>(or <strong>Website → Configuration → Payment Providers</strong>, or <strong>Settings → Payments</strong>).
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="example-box-wrapper mb-30">
                                        <div className="d-flex align-items-start">
                                            <b>2 </b>
                                            <div>
                                                <p>
                                                    Open the <strong> TCB Pay</strong> provider in the list.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="example-box-wrapper mb-30">
                                        <div className="d-flex align-items-start">
                                            <b>3 </b>
                                            <div>
                                                <p>
                                                    On the <strong>Credentials</strong> tab, enter the values from your TCB Pay Merchant Portal:
                                                </p>

                                                <ul className='list-unstyled mt-3'>
                                                    <li><strong>Username</strong> [API Username]</li>
                                                    <li><strong>API Key</strong> [API Key]</li>
                                                    <li><strong>API Secret</strong> [API Secret]</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="example-box-wrapper mb-30">
                                        <div className="d-flex align-items-start">
                                            <b>4 </b>
                                            <div>
                                                <p>
                                                    Set the <strong>State</strong> of the provider:
                                                </p>

                                                <ul className='list-unstyled mt-3'>
                                                    <li><strong>Test Mode</strong> — for sandbox testing (no real charges).</li>
                                                    <li><strong>Enabled</strong> — live, processing real payments.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <img src="../assets/imgs/odoo3.png" alt="Method C" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={ `${ config.siteBaseUrl }/assets/imgs/blue-lowerdots.svg` } alt="" className="orng-dots" />
                </div>

                <ScrollToTop smooth />
            </section>
        </>
    )
}
